import React from 'react';

export default class Logout extends React.Component {

  constructor(props) {
    super(props);

  }
  componentDidMount() {
  localStorage.removeItem('token');
  localStorage.removeItem('timestamp');
  let path = "/login"
  if (localStorage.getItem('org') !== "undefined") {
    path= `/${localStorage.getItem('org')}/login`
  }

  this.props.history.push(path);
  }
  render() {
    return (
      <div>

      </div>
    );
  }
}
